import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

/**
 * A state which contains the entry text and active element triggered from any channel dbb/net
 */
const triggerChatWindow = atom({
  key: 'triggerChatWindow',
  default: {},
});

export const useTriggerChatWindow = () => useRecoilValue(triggerChatWindow);

export const useSetTriggerChatWindow = () =>
  useSetRecoilState(triggerChatWindow);
